import * as i18next from 'i18next';

import { CellRenderer } from '../../../TableGrid';
import { TableGridApiRowSelectionIdGetter } from '../../../TableGridApiContext/TableGridApiContext.types';
import HeaderSelectAllRenderer from './HeaderSelectAllRenderer';

export const getNodeIdGetter = (
  rowSelectionIdGetter: TableGridApiRowSelectionIdGetter = (node: any) => String(node.rowIndex),
) => rowSelectionIdGetter;

export const getSelectAllColumn = (t: i18next.TFunction) => ({
  headerName: `${t('app:datagrid:selector')}`,
  headerComponentFramework: HeaderSelectAllRenderer,
  cellRenderer: CellRenderer.SelectRow,
  field: '',
  minWidth: 52,
  maxWidth: 52,
  width: 52,
  pinned: true,
  lockPosition: true,
  lockVisible: true,
  lockPinned: true,
});
